<div class="full-table-wrapper d-flex items-center flex-gap-half">
    <div class="tooltip" *ngIf="props.tooltipForPrimary;else table_field">
        <span [ngClass]="props.disabled ? '' : 'tooltiptext'">{{props.disabled ? '' : props.tooltipForPrimary}}</span>
        <ng-container #fieldComponent>
        </ng-container>
    </div>
    
    <ng-template #table_field>
        <div class="tooltipAuto">
            <span class="tooltiptextAuto" [hidden]="!props.disabled">{{props.tooltipForAutoTable}}</span>
            <ng-container #fieldComponent></ng-container>
        </div>
        <span class="tooltip hover-tooltip tooltip-sm" [hidden]="!props.isFullLoadSupported">
            <img class="full-load" src="./assets/images/new/full-load.svg" alt="">
            <div class="tooltip-section tooltip-left-0 fade-in m-l-20p">
                <div class="tooltip-body">
                    Data is loaded into warehouse by Full Load method.<br> For
                    more details refer to our documentation </div>
            </div>
        </span>
    </ng-template>
</div>